export default __webpack_public_path__ + "static/media/play-cursor.13fbb5f9.png";